module.exports = __webpack_public_path__ + "static/wave-4c4d67763187e5fd0d75b87fd1df8a9c.png";